import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: t, useRem: l, color: c, withColor: o, removeClassName: n, disableSSR: p, style: i, ...m }) => {
  const v = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: p }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-yanshengpin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: v, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "24px-è¡çå"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M15.16 7.417c-.41-.897-1.685-.897-2.094 0l-.735 1.61-1.758.201c-.98.113-1.374 1.325-.647 1.992l1.303 1.196-.351 1.735c-.196.966.835 1.716 1.694 1.23l1.54-.87 1.541.87c.86.486 1.89-.264 1.695-1.23l-.352-1.735L18.3 11.22c.727-.667.333-1.88-.647-1.992l-1.758-.201-.735-1.61Zm-1.561 2.685.514-1.126.514 1.126a.8.8 0 0 0 .637.463l1.23.141-.913.837a.8.8 0 0 0-.243.748l.246 1.214-1.078-.61a.8.8 0 0 0-.787 0l-1.078.61.246-1.214a.8.8 0 0 0-.243-.748l-.912-.837 1.23-.141a.8.8 0 0 0 .637-.463Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M8.747 2.1a2.811 2.811 0 0 0-2.81 2.811v5.459H4.292a2.206 2.206 0 0 0-2.206 2.206v4.98c0 2.23 1.68 4.073 3.85 4.322v.022h.257c.066.004.132.006.199.007a.804.804 0 0 0 .111-.007H19.05a2.811 2.811 0 0 0 2.812-2.811V4.91A2.811 2.811 0 0 0 19.05 2.1H8.746ZM19.05 3.7H8.747a1.21 1.21 0 0 0-1.21 1.211V20.3H19.05a1.21 1.21 0 0 0 1.21-1.211V4.91a1.21 1.21 0 0 0-1.21-1.211ZM4.293 11.97h1.643v8.291a2.752 2.752 0 0 1-2.249-2.705v-4.98c0-.335.272-.606.606-.606Z"
        }
      )
    )
  )));
}, E = f;
export {
  E as default
};
